<template>
  <div>
    <div v-if="userHasPermissionTo('list')">
      <v-data-table
        :headers="headers"
        :items="ticketComments"
        :page.sync="pagination.page"
        :items-per-page.sync="paginationTicketComments.rowsPerPage"
        :items-per-page-text="rowsPerPageText"
        :items-per-page-items="rowsPerPageItems"
        :header-props="{ sortIcon }"
        :footer-props="{ prevIcon, nextIcon,'items-per-page-options': rowsPerPageItems }"
        class="elevation-2"
        :class="{ 'no-show-permission': !userHasPermissionTo('show') }"
        @pagination="setRowsOnLocalStorage(dataTableTicketCommentsTableId,paginationTicketComments.rowsPerPage)"
      >
        <template v-slot:item="props">
          <tr
            @click="viewItem(props.item)"
            :class="{ 'cursor-pointer': userHasPermissionTo('show') }"
          >
            <td>{{ props.item.id }}</td>

            <td
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 800px;
              "
            >
              {{ props.item.text }}
            </td>

            <td>{{ props.item.author.name }}</td>

            <td v-if="userCanEditOrRemoveItems">
              <app-datatable-action-buttons
                :user-can-delete="userCanDeleteComment(props.item.author.id)"
                @delete="askConfirmationToDeleteItem(props.item)"
                :user-can-edit="userCanEditComment(props.item.author.id)"
                @edit="editComment(props.item.id)"
              />
            </td>
          </tr>
        </template>

        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
      <app-dialog-box
        :open="deleteDialog"
        :title="$t('DeleteComment')"
        :content="$t('DeleteConfirmation') + ' ' + itemToDelete.id + '?'"
        :main-action-label="$t('No')"
        @mainAction="cancelDelete"
        :secondary-action-label="$t('Yes')"
        @secondaryAction="deleteComment"
        :loading="loadingDelete"
      />
    </div>

    <app-no-permission-warning v-else />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import DataTableNoResults from "@/components/_Atoms/DataTableNoResults";
import AppNoPermissionWarning from "@/components/_Molecules/AppNoPermissionWarning";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "TicketCommentsTable",

  components: {
    DataTableNoResults,
    AppNoPermissionWarning,
    AppDatatableActionButtons,
    AppDialogBox
  },

  mixins: [managementDatatableMixin, checkPermissionsMixin],

  props: {
    ticketId: {
      type: String
    }
  },

  data() {
    return {
      ticketComments: [],

      permissionName: "third_party_apis_youtrack_comments",

      loadingDelete: false,
      dataTableTicketCommentsTableId: "dataTableTicketCommentsTableId" ,
      paginationTicketComments: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableTicketCommentsTableId")
      },
      pagination: {
        sortBy: "id",
        descending: true
      }
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.tc("ID"),
          value: "id",
          width: "20%"
        },
        {
          text: this.$i18n.tc("Comment", 1),
          value: "text",
          width: "50%"
        },
        {
          text: this.$i18n.t("Author"),
          value: "author.name",
          width: "20%"
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "15%"
        }
      ];
    }
  },

  watch: {
    ticketId() {
      this.getTicketComments();
    }
  },

  mounted() {
    this.getTicketComments();
  },

  methods: {
    ...mapActions(["fetchTicketComments", "deleteCommentByID"]),

    viewItem(comment) {
      this.$emit("open-comment", comment);
    },

    async getTicketComments() {
      if (this.ticketId) {
        this.loading = true;
        try {
          this.ticketComments = await this.fetchTicketComments(this.ticketId);
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
        }
      }
    },

    async deleteComment() {
      try {
        this.loadingDelete = true;
        await this.deleteCommentByID({
          commentID: this.itemToDelete.id,
          ticketID: this.ticketId
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.deleteDialog = false;
        this.loadingDelete = false;
        this.getTicketComments();
      }
    },

    userIsTheAuthor(userID) {
      return userID === this.$store.getters.currentUserID ? true : false;
    },

    userCanDeleteComment(userID) {
      return userID
        ? this.userHasPermissionTo("destroy") && this.userIsTheAuthor(userID)
        : this.userHasPermissionTo("destroy");
    },

    userCanEditComment(userID) {
      return userID
        ? this.userHasPermissionTo("update") && this.userIsTheAuthor(userID)
        : this.userHasPermissionTo("update");
    },

    editComment(commentID) {
      if (this.userHasPermissionTo("update")) {
        this.$router.push({
          name: "comments-edit",
          params: {
            id: this.ticketId,
            commentId: commentID
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Support/TechnicalSupport/TicketCommentsTable.vue